import {postRequest} from "../api";

export const getIndicatorList = (query, variables, serverOptions) => {
  return postRequest(
    "/graphql",
    {query, variables},
    {
      serverOptions
    }
  );
};
